import {gsap, ScrollTrigger} from "gsap/all";
gsap.registerPlugin(ScrollTrigger)


window.addEventListener('load', () => {
    transformStep()
})



function transformStep() {
    let isMobile = window.matchMedia("(max-width: 768px)").matches
    let cards = document.querySelectorAll('[data-img-anim]')
    cards.forEach(block => {
        const animateCard = gsap.timeline()
        animateCard.to(block, {y:  isMobile ? -40 : -100}, 0)
        ScrollTrigger.create({
            trigger: block,
            start: '100% 100%',
            end: 'bottom 10%',
            animation: animateCard,
            scrub: 0.5,
            scrub: 0,
        })
    })
}





